import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PLANNED_TASKS_QUERY,
    SINGLE_PLANNED_TASK_QUERY,
    CREATE_PLANNED_TASK_MUTATION,
    UPDATE_PLANNED_TASK_MUTATION,
    UPDATE_PLANNED_TASK_STATUS_MUTATION,
    DELETE_PLANNED_TASK_MUTATION,
} from "@/graphql/plannedTasks.js";

const state = {
    plannedTasks: []
};

const getters = {};

const mutations = {
    [types.SET_PLANNED_TASKS](state, plannedTasks) {
        state.plannedTasks = plannedTasks;
    },
    [types.SORT_PLANNED_TASKS](state) {
        state.plannedTasks.sort(function(a, b) {
            // first sort by greenhouse name, then sort by department name
            return a.node.plant.name.toLowerCase() ==
                b.node.plant.name.toLowerCase()
                ? 0
                : a.node.plant.name.toLowerCase() >
                  b.node.plant.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PLANNED_TASK](state, plannedTask) {
        var index = state.plannedTasks.findIndex(function(element) {
            return element.node.id == plannedTask.id;
        });

        const node = { node: plannedTask };

        if (index > -1) {
            state.plannedTasks.splice(index, 1, node);
        } else {
            state.plannedTasks.unshift(node);
        }
    },
    [types.DELETE_PLANNED_TASK](state, plannedTask) {
        var index = state.plannedTasks.find(function(element, index) {
            if (element.id == plannedTask.id) {
                return index;
            }
        });

        if (index > -1) {
            state.plannedTasks.splice(index, 1);
        }
    }
};

const actions = {
    async fetchPlannedTasks(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PLANNED_TASKS_QUERY,
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // console.log(response);

                    // Option 1: if need extra calculate for each node, use this option
                    // const plannedTasks = response.data.plannedTasks.edges.map(
                    //     item => {
                    //         return {
                    //             node: item.node
                    //         };
                    //     }
                    // );

                    // Option 2
                    const plannedTasks = response.data.tenantPlannedTasks.edges;

                    // set
                    context.commit(types.SET_PLANNED_TASKS, plannedTasks);

                    // sort
                    context.commit(types.SORT_PLANNED_TASKS);

                    resolve(plannedTasks);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglePlannedTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PLANNED_TASK_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const plannedTask = JSON.parse(
                        JSON.stringify(response.data.plannedTask)
                    );

                    // // update store
                    // context.commit(types.UPSERT_PLANNED_TASK, plannedTask);

                    // // sort
                    // context.commit(types.SORT_PLANNED_TASKS);

                    resolve(plannedTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createPlannedTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_PLANNED_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const plannedTask = JSON.parse(
                        JSON.stringify(
                            response.data.createPlannedTask.plannedTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_PLANNED_TASK, plannedTask);

                    // sort
                    context.commit(types.SORT_PLANNED_TASKS);

                    resolve(plannedTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePlannedTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PLANNED_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const plannedTask = JSON.parse(
                        JSON.stringify(
                            response.data.updatePlannedTask.plannedTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_PLANNED_TASK, plannedTask);

                    // sort
                    context.commit(types.SORT_PLANNED_TASKS);

                    resolve(plannedTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePlannedTaskStatus(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PLANNED_TASK_STATUS_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const plannedTask = JSON.parse(
                        JSON.stringify(
                            response.data.updatePlannedTaskStatus.plannedTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_PLANNED_TASK, plannedTask);

                    // sort
                    context.commit(types.SORT_PLANNED_TASKS);

                    resolve(plannedTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deletePlannedTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PLANNED_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const plannedTask = JSON.parse(
                        JSON.stringify(
                            response.data.deletePlannedTask.plannedTask
                        )
                    );

                    // delete
                    context.commit(types.DELETE_PLANNED_TASK, plannedTask);

                    resolve(plannedTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
